module.exports = __webpack_public_path__ + "img/4.852a0498.png";